{
    "warning": "AMARAN!",
    "message": "Jangan masukkan atau tampal kod yang anda tidak faham.\nPenggunaan konsol ini membenarkan penyerang untuk menyamar sebagai anda dan mencuri maklumat anda menggunakan serangan yang dipanggil XSS-Kendiri (Self-XSS)"
}
